import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/login.log.css';
import { decodeJwtPayload, hasAdminAccess, saveAuthSession } from '../utils/auth';
export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  function togglePassword() {
    setShowPassword(s => !s);
  }

  function showMessage(text, type) {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 4000);
  }

  // Submit login to backend
  async function handleLogin(e) {
    e.preventDefault();
    const form = e.target;
    const email = form.email.value?.trim();
    const password = form.password.value;
    const rememberMe = Boolean(form.remember?.checked);

    if (!email || !password) {
      showMessage('Por favor completa email y contraseña', 'error');
      return;
    }

    setLoading(true);
    try {
      const base = process.env.REACT_APP_API_BASE_URL || '';
      const res = await fetch(`${base}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, remember: rememberMe })
      });

      const data = await res.json().catch(() => ({}));
      setLoading(false);

      if (!res.ok) {
        // Prefer backend message, fallback by status
        const msg = data.message || (res.status === 401 ? 'Credenciales inválidas' : 'Los datos no son correctos o no está registrado');
        showMessage(msg, 'error');
        return;
      }

      // Expect backend to return a JWT token. Try common keys.
      const token = data.token || data.accessToken || data.access_token || data.jwt;
      if (!token) {
        showMessage('Login correcto pero no se recibió token', 'error');
        return;
      }

      const resolvedUser = data.user || { name: email, role: 'Usuario' };

      saveAuthSession({
        token,
        refreshToken: data.refreshToken || data.refresh_token || '',
        expiresIn: data.expires_in,
        refreshExpiresAt: data.refreshExpiresAt || data.refresh_expires_at,
        user: resolvedUser,
        rememberMe
      });

      const tokenPayload = decodeJwtPayload(token);
      const isAdmin = hasAdminAccess(resolvedUser, tokenPayload);

      showMessage('¡Inicio de sesión exitoso!', 'success');
      // Redirect to original destination if present
      const from = location.state && location.state.from && location.state.from.pathname;

      if (isAdmin) {
        navigate('/admin', { replace: true });
        return;
      }

      if (from === '/admin') {
        navigate('/dashboard', { replace: true });
        return;
      }

      navigate(from || '/dashboard', { replace: true });
    } catch (err) {
      setLoading(false);
      showMessage('No se pudo conectar al servidor. Intenta nuevamente.', 'error');
      // console.error(err);
    }
  }

  function handleForgotPassword(e) {
    e.preventDefault();
    // Navigate to the password recovery page
    navigate('/recover');
  }

  function handleRegister(e) {
    e.preventDefault();
    // navigate to register page without showing an alert
    navigate('/register');
  }

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="logo-container">
          <a href="/" aria-label="Ir a inicio">
            <img src="/logo512.png" alt="Ker Logo" className="logo-icon" />
          </a>
        </div>

        <div className="login-header">
          <h1 className="login-title" id="form-title">Iniciar Sesión</h1>
          <p className="login-subtitle" id="form-subtitle">Accede a tu plataforma IoT</p>
        </div>

        {message && <div className={`message ${message.type}`}>{message.text}</div>}

        <form id="login-form" onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email" id="email-label">Correo electrónico</label>
            <div className="input-wrapper">
              <span className="input-icon">📧</span>
              <input type="email" className="with-icon" id="email" name="email" placeholder="correo@ejemplo.com" required autoComplete="email" />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password" id="password-label">Contraseña</label>
            <div className="input-wrapper">
              <span className="input-icon">🔒</span>
              <input type={showPassword ? 'text' : 'password'} className="with-icon" id="password" name="password" placeholder="••••••••" required autoComplete="current-password" />
              <button type="button" className="password-toggle" onClick={togglePassword} aria-label="Mostrar contraseña">{showPassword ? '👁️‍🗨️' : '👁️'}</button>
            </div>
          </div>

          <div className="form-options">
            <label className="remember-me"><input type="checkbox" id="remember" name="remember" /> <span>Recordarme</span></label>
            <button type="button" className="forgot-password" id="forgot-password" onClick={handleForgotPassword}>¿Olvidaste tu contraseña?</button>
          </div>

          <button type="submit" className="login-button" id="login-btn" disabled={loading}>
            <span className="button-content">
              <span id="button-text">Ingresar</span>
              {loading && <div className="loading-spinner" id="loading-spinner" />}
            </span>
          </button>
        </form>

        <div className="register-link"><span id="register-text">¿No tienes cuenta? <button type="button" className="register-cta" onClick={handleRegister}>Regístrate</button></span></div>
      </div>
    </div>
  );
}
